import React from 'react';
import { siteContent } from '../data/mock';

export const HowItWorks = () => {
  const { howItWorks } = siteContent;

  return (
    <section id="how-it-works" className="bg-white border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 text-center">
          {howItWorks.title}
        </h2>
        
        <div className="mt-10 grid gap-6 sm:grid-cols-3">
          {howItWorks.steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 bg-[#2C3E50] text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto">
                {step.number}
              </div>
              <h3 className="mt-4 text-lg font-semibold text-stone-900">
                {step.title}
              </h3>
              <p className="mt-2 text-stone-600 text-sm">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
